<form *ngIf="form" [formGroup]="form" class="form-layout">
  <ng-container *ngIf="languageOptions$ | async; let languageOptions">
    <loop-select-control
      [formControlName]="LanguageSelectorFormControlName.from"
      label="From"
      [labelOnTop]="true"
      [options]="fromLanguageOptions$ | async"
    >
    </loop-select-control>

    <loop-select-control
      [formControlName]="LanguageSelectorFormControlName.to"
      label="To"
      [labelOnTop]="true"
      [options]="languageOptions"
    >
    </loop-select-control>
  </ng-container>
</form>
